// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__VIPpL","content":"GlobalSearch_content__1URHd"};